import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { proposalMutationScopeId } from '@/api/mutations/proposals/proposalMutationScope';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  SetProposalLineItemQuantityInput,
  SetProposalLineItemQuantityMutation,
} from '@/gql/graphql';

const SET_PROPOSAL_LINE_ITEM_QUANTITY_MUTATION = graphql(`
  mutation SetProposalLineItemQuantity(
    $input: SetProposalLineItemQuantityInput!
  ) {
    setProposalLineItemQuantity(input: $input) {
      id
    }
  }
`);

const useSetProposalLineItemQuantity = (args?: {
  proposalId?: string;
  options?: UseMutationOptions<
    SetProposalLineItemQuantityMutation,
    unknown,
    SetProposalLineItemQuantityInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: SetProposalLineItemQuantityInput) => {
      return gqlClient.request(SET_PROPOSAL_LINE_ITEM_QUANTITY_MUTATION, {
        input,
      });
    },
    scope: args?.proposalId
      ? { id: proposalMutationScopeId(args.proposalId) }
      : undefined,
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useSetProposalLineItemQuantity;
